import React from "react";
import styled from 'styled-components';
import { MdHistory } from 'react-icons/md';
import "bootstrap/dist/css/bootstrap.min.css";

const TicketHistory = () => {
    return (
        <Wrapper>
      <div className="container py-5">
        <div className="card border-0 shadow-sm p-4">
          <div className="container mt-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
              <div>
                <h4 className="text-dark mb-1 d-flex align-items-center">
                  <MdHistory className="me-2" size={22} color="black" />
                  All Tickets Log
                </h4>
                <p className="text-muted mb-0">View, filter, and manage all ticket records.</p>
              </div>
              <div className="mt-2 mt-md-0">
                <button className="btn btn-outline-primary me-2">Verify Ticket</button>
                <button className="btn btn-primary">Generate Ticket</button>
              </div>
            </div>

            {/* Filters & Search */}
            <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
              <div style={{ minWidth: "250px", flexGrow: 1 }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by ID, Visitor, Phone..."
                />
              </div>

              <button className="btn btn-outline-secondary">All Tickets</button>

              <select className="form-select" style={{ width: "140px" }}>
                <option>All Spots</option>
                <option>Online</option>
                <option>Counter</option>
              </select>

              <button className="btn btn-outline-secondary">Ticket Status</button>

              <select className="form-select" style={{ width: "140px" }}>
                <option>All Time</option>
                <option>Today</option>
                <option>Last 7 Days</option>
              </select>

              <button className="btn btn-outline-secondary">Export</button>
              <button className="btn btn-outline-danger">Clear Filters</button>
            </div>

            {/* Table */}
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th>Ticket ID</th>
                    <th>Spot Name</th>
                    <th>Visitor Details</th>
                    <th>Booking Date & Time</th>
                    <th>Visit Date</th>
                    <th>Qty</th>
                    <th>Ticket Type</th>
                    <th>Ticket Status</th>
                    <th>Revenue</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>TKT001</td>
                    <td>Mountain View Peak</td>
                    <td>
                      Alice Wonderland<br />
                      <small>555-0101</small>
                    </td>
                    <td>15 Jul 2024, 3:30 PM</td>
                    <td>01 Aug 2024</td>
                    <td>2</td>
                    <td><span className="badge badge-opacity-primary">Online</span></td>
                    <td><span className="badge badge-opacity-success">Active</span></td>
                    <td>$40.00</td>
                  </tr>
                  <tr>
                    <td>TKT002</td>
                    <td>City Museum Exhibit</td>
                    <td>
                      Bob The Builder<br />
                      <small>555-0102</small>
                    </td>
                    <td>18 Jul 2024, 4:30 PM</td>
                    <td>20 Jul 2024</td>
                    <td>1</td>
                    <td><span className="badge badge-opacity-primary">Online</span></td>
                    <td><span className="badge badge-opacity-warning">Used</span></td>
                    <td>$15.00</td>
                  </tr>
                  <tr>
                    <td>TKT003</td>
                    <td>Lakeside Boat Tour</td>
                    <td>
                      Charlie Brown<br />
                      <small>555-0103</small>
                    </td>
                    <td>20 Jun 2024, 7:30 PM</td>
                    <td>01 Jul 2024</td>
                    <td>4</td>
                    <td><span className="badge badge-opacity-primary">Online</span></td>
                    <td><span className="badge badge-opacity-danger">Expired</span></td>
                    <td>$100.00</td>
                  </tr>
                  <tr>
                    <td>CNT001</td>
                    <td>Mountain View Peak</td>
                    <td>
                      Walk-in Customer<br />
                      <small>N/A</small>
                    </td>
                    <td>20 Jul 2024, 3:00 PM</td>
                    <td>20 Jul 2024</td>
                    <td>1</td>
                    <td><span className="badge badge-opacity-secondary">Counter</span></td>
                    <td><span className="badge badge-opacity-success">Active</span></td>
                    <td>$20.00</td>
                  </tr>
                  <tr>
                    <td>CNT002</td>
                    <td>City Museum Exhibit</td>
                    <td>
                      John Smith<br />
                      <small>555-0104</small>
                    </td>
                    <td>21 Jul 2024, 9:45 AM</td>
                    <td>21 Jul 2024</td>
                    <td>3</td>
                    <td><span className="badge badge-opacity-secondary">Counter</span></td>
                    <td><span className="badge badge-opacity-warning">Used</span></td>
                    <td>$45.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
    );
};

export default TicketHistory;
const Wrapper = styled.div`
  .badge-opacity-primary {
    background-color: rgba(13, 110, 253, 0.15) !important;
    color: #0d6efd;
    font-size: 10px;
    padding: 5px 10px;
  }

  .badge-opacity-success {
    background-color: rgba(25, 135, 84, 0.15) !important;
    color: #198754;
    font-size: 10px;
    padding: 5px 10px;
  }

  .badge-opacity-warning {
    background-color: rgba(255, 193, 7, 0.15) !important;
    color: #856404;
    font-size: 10px;
    padding: 5px 10px;
  }

  .badge-opacity-danger {
    background-color: rgba(220, 53, 69, 0.15) !important;
    color: #dc3545;
    font-size: 10px;
    padding: 5px 10px;
  }

  .badge-opacity-secondary {
    background-color: rgba(108, 117, 125, 0.15) !important;
    color: #6c757d;
    font-size: 10px;
    padding: 5px 10px;
  }
`;
